import { IconType } from '@/components/view/atoms/icon/Icon'
import AiLoading from '@/components/view/atoms/loading/AiLoading'
import AiLoadingArea from '@/components/view/layouts/loading/AiLoadingArea'

export interface AnalysisProgress {
  step: number
  total_steps: number
  percent: number
  message: string
  detail?: string
}

export interface AnalysisProgressStep {
  label: string
  icon: IconType
}

interface Props {
  progress: AnalysisProgress
  steps: AnalysisProgressStep[]
}

// RewriteProgressStepper のステップ定義を外から渡せる汎用版
const AnalysisProgressStepper = ({ progress, steps }: Props) => {
  return (
    <AiLoadingArea type='modal'>
      <AiLoading
        description={progress.message}
        prompt={`${progress.percent}% : ${progress.detail}`}
      />
    </AiLoadingArea>
  )
}

export default AnalysisProgressStepper
